import axios from 'axios';
import router from './router';
import { getToken, deleteToken, removeXBUserName, getXBGuestSetting } from 'common/js/storage';

// 前端登录过期标记
const FROENT_FLAG = 'fore'
// 后端登录过期标记
const SERVICE_FLAG = 'back'
// 供应商登录过期标记
const SUPPLIER_FLAG = 'supplier'

// axios 配置
axios.defaults.timeout = 60000

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'
    let token = getToken()
    if (token) {
      // 将token设置成请求头
      config.headers['Auth-Token'] = token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    switch (response.data.code) {
      case 401:
        deleteToken();
        removeXBUserName();
        // 401默认重新登录，先清除浏览器localStorage的缓存
        // window.localStorage.clear()
        // if (response.data.flag === FROENT_FLAG) {
        //   // 前端用户Token过期重新登录
        //   let str = window.location.pathname.split('/')[1];
        //   if (str === 'admin') {
        //     router.replace({
        //       path: '/admin/login'
        //     })
        //   } else if (str === 'supplier') {
        //     router.replace({
        //       path: '/supplier/spl-user'
        //     })
        //   } else {
        //     router.replace({
        //       path: '/'
        //     })
        //     location.reload(true);
        //   }
        // } else if (response.data.flag === SERVICE_FLAG) {
        //   let str = window.location.pathname.split('/')[1];
        //   if (str === 'homepage') {
        //     router.replace({
        //       path: '/'
        //     })
        //     location.reload(true);
        //   } else if (str === 'supplier') {
        //     router.replace({
        //       path: '/supplier/spl-user'
        //     })
        //   } else {
        //     router.replace({
        //       path: '/admin/login'
        //     })
        //   }
        // } else if (response.data.flag === SUPPLIER_FLAG) {
        //   let str = window.location.pathname.split('/')[1];
        //   if (str === 'homepage') {
        //     router.replace({
        //       path: '/'
        //     })
        //     location.reload(true);
        //   } else if (str === 'admin') {
        //     router.replace({
        //       path: '/admin/login'
        //     })
        //   } else {
        //     router.replace({
        //       path: '/supplier/spl-user'
        //     })
        //   }
        // } else {
          let str = window.location.pathname.split('/')[1];
          if (str === 'admin') {
            router.replace({
              path: '/admin/login'
            })
          } else if (str === 'supplier') {
            router.replace({
              path: '/supplier/spl-user'
            })
          } else {
            if (getXBGuestSetting().guestLogin !== 1) {
              router.replace({
                path: '/user-login',
                query: { redirect: router.currentRoute.fullPath }
              })
            } else {
              router.push("/");
            }
          }
        // }
        return Promise.reject(response)
        break;
      case 600:
        router.replace({
          path: '/user-login'
        })
        return Promise.reject(response)
        break;
      case 700:
        router.replace({
          path: "/404"
        });
        break;
      default: return response;
    }
  },
  err => {
    // if (err.response) {
    //   switch (err.response.status) {
    //     case 401:
    //       deleteToken();
    //       removeXBUserName();
    //       // 401默认重新登录，先清除浏览器localStorage的缓存
    //       // window.localStorage.clear()
    //       if (err.response.data.flag === FROENT_FLAG) {
    //         // 前端用户Token过期重新登录
    //         let str = window.location.pathname.split('/')[1];
    //         if (str === 'admin') {
    //           router.replace({
    //             path: '/admin/login'
    //           })
    //         } else if (str === 'supplier') {
    //           router.replace({
    //             path: '/supplier/spl-user'
    //           })
    //         } else {
    //           router.replace({
    //             path: '/'
    //           })
    //           location.reload(true);
    //         }
    //       } else if (err.response.data.flag === SERVICE_FLAG) {
    //         let str = window.location.pathname.split('/')[1];
    //         if (str === 'homepage') {
    //           router.replace({
    //             path: '/'
    //           })
    //           location.reload(true);
    //         } else if (str === 'supplier') {
    //           router.replace({
    //             path: '/supplier/spl-user'
    //           })
    //         } else {
    //           router.replace({
    //             path: '/admin/login'
    //           })
    //         }
    //       } else if (err.response.data.flag === SUPPLIER_FLAG) {
    //         let str = window.location.pathname.split('/')[1];
    //         if (str === 'homepage') {
    //           router.replace({
    //             path: '/'
    //           })
    //           location.reload(true);
    //         } else if (str === 'admin') {
    //           router.replace({
    //             path: '/admin/login'
    //           })
    //         } else {
    //           router.replace({
    //             path: '/supplier/spl-user'
    //           })
    //         }
    //       } else {
    //         let str = window.location.pathname.split('/')[1];
    //         if (str === 'admin') {
    //           router.replace({
    //             path: '/admin/login'
    //           })
    //         } else if (str === 'supplier') {
    //           router.replace({
    //             path: '/supplier/spl-user'
    //           })
    //         } else {
    //           router.replace({
    //             path: '/user-login',
    //             query: { redirect: router.currentRoute.fullPath }
    //           })
    //         }
    //       }
    //       break;
    //     case 600:
    //       router.replace({
    //         path: '/user-login'
    //       })
    //       break;
    //     default:
    //       break;
    //   }
    // }
    return Promise.reject(err.response)
  }
)

export default axios;
